import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Send, Smile } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EMOJIS = ["😀", "😂", "😍", "🥰", "😎", "🤩", "👍", "🙏", "🔥", "✨", "💄", "💅", "💋", "🎉", "❤️", "💯", "👏", "😉", "😊", "🤝", "📸", "🎥", "🛍️", "⭐"];

export default function GroupForum({ channel }) {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = async () => {
    try { const r = await api.get(`/forum/${channel}/messages`); setMessages(r.data); } catch (e) {}
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try { await api.post(`/forum/${channel}/messages`, { body: text.trim() }); setText(""); load(); }
    finally { setSending(false); }
  };

  return (
    <div className="flex flex-col h-[520px] rounded-2xl border border-border bg-white overflow-hidden" data-testid={`group-forum-${channel}`}>
      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-showty-cream/40">
        {messages.length === 0 && <p className="text-center text-sm text-muted-foreground mt-8">Belum ada pesan. Mulai percakapan komunitas!</p>}
        {messages.map((m) => {
          const mine = m.sender_id === user?.user_id;
          const adminMsg = m.sender_role === "manager";
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`fmsg-${m.id}`}>
              <div className={`max-w-[75%] rounded-2xl px-4 py-2 ${mine ? "bg-showty-red text-white" : adminMsg ? "bg-showty-navy text-white" : "bg-white border border-border text-showty-navy"}`}>
                {!mine && <p className="text-[11px] opacity-75 mb-0.5">{m.sender_name}{adminMsg ? " · Admin" : ""}</p>}
                <p className="text-sm whitespace-pre-wrap break-words">{m.body}</p>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <div className="p-3 border-t border-border flex gap-2 items-center">
        <Popover>
          <PopoverTrigger asChild>
            <button className="w-9 h-9 rounded-full flex items-center justify-center text-showty-navy hover:bg-showty-pink/40 shrink-0" data-testid="forum-emoji-btn"><Smile className="w-5 h-5" /></button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-56 p-2" data-testid="forum-emoji-panel">
            <div className="grid grid-cols-6 gap-1">
              {EMOJIS.map((e) => (
                <button key={e} onClick={() => setText((t) => t + e)} className="text-xl hover:bg-showty-pink/40 rounded p-1" data-testid={`emoji-${e}`}>{e}</button>
              ))}
            </div>
          </PopoverContent>
        </Popover>
        <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} placeholder="Tulis pesan…" data-testid="forum-input" />
        <Button onClick={send} disabled={sending} className="rounded-full bg-showty-red hover:bg-[#9e1f24] text-white shrink-0" data-testid="forum-send"><Send className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
